import React, { memo, useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AdminSideBar from "../shared/AdminSidebar";
import AdminHeader from "../shared/AdminHeader";
import { useSelector } from "react-redux";
import { setTitle } from "../../helpers/MetaTag";
import Button from "../../components/form/Button";
import { classNames } from "../../helpers/classNames";
import Select from "../../components/form/select/Select";
import { useDispatch } from "react-redux";
import { setLanguage } from "../../redux/slice/languageSlice";
import { rgba } from "../../helpers";
import styles from "../../components/sections/admin/site-settings/components/style/Themes.module.css";
import SidebarMode from "../shared/SidebarMode";

const AdminLayout = ({ metaTitle }) => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const profile = useSelector((state) => state?.profile?.data);
  const settings = useSelector((state) => state?.settings?.data);
  const { session } = useSelector((state) => state?.authProvider);
  const { lang } = useSelector((state) => state?.langProvider);
  const { appliedTheme, selectedElement, status } = useSelector(
    (state) => state?.themeProvider
  );
  const location = useLocation();

  useEffect(() => {
    if (window.innerWidth < 1280) {
      setMenuOpen(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    setTitle(`${metaTitle}`);
  }, [metaTitle, session]);

  useEffect(() => {
    if (settings?.favicon?.url) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      link.href = settings?.favicon?.url;
    }
  }, [settings]);

  const [isHeaderExpanded, setIsHeaderExpanded] = useState(false);

  return (
    <>
      <div className="relative flex w-full min-h-screen overflow-x-hidden">
        <div>
          <div className="fixed top-5 left-4 z-[50] xls:hidden">
            {!isMenuOpen && (
              <Button
                buttonClasses={"!h-8 !w-8 !rounded-full !px-0"}
                buttonHasLink={false}
                buttonIcon={"fa-light fa-arrow-right text-sm md:text-xl"}
                buttonIconPosition={"left"}
                buttonFunction={() => setMenuOpen(true)}
              />
            )}
          </div>

          <div
            className={classNames(
              "fixed top-0 left-0 h-full w-[260px] z-50 flex flex-col transition-transform duration-300 border-r",
              isMenuOpen ? "translate-x-0" : "-translate-x-full",
              "xls:translate-x-0",
              "bg-[#dce3da]"
            )}
            // {...(appliedTheme?.sidePanel?.backgroundColor && {
            //   style: {
            //     backgroundColor: rgba(appliedTheme?.sidePanel?.backgroundColor),
            //   },
            // })}
          >
            <div className="flex-shrink flex-grow">
              {/* <AdminSideBar isMenuOpen={isMenuOpen} setMenuOpen={setMenuOpen}  isHeaderExpanded={isHeaderExpanded}/> */}
              <AdminSideBar isHeaderExpanded={isHeaderExpanded}/>
            </div>
            <div className="flex-shrink flex-grow">
              <AdminHeader profile={profile}  setIsOpen={setIsHeaderExpanded} isOpen={isHeaderExpanded}/>
            </div>
            {/* <div className="flex-shrink flex-grow">
              <SidebarMode/>
            </div> */}
          </div>

          <div
            className={classNames(
              "fixed inset-0 bg-black/75 z-20 transition-opacity duration-300 xls:hidden",
              isMenuOpen ? "opacity-100 visible" : "opacity-0 invisible"
            )}
            onClick={() => setMenuOpen(false)}
          />
        </div>

        <div
          className={classNames(
            "relative w-full flex flex-col transition-all duration-300",
            "p-0",
            "xls:pl-[260px]"
          )}
        >
          {/* <div
            className={classNames(
              "h-14 px-3 py-2 shadow-md",
              appliedTheme?.previewPanelHeader?.backgroundColor
                ? ""
                : "bg-white"
            )}
            {...(appliedTheme?.previewPanelHeader?.backgroundColor && {
              style: {
                backgroundColor: rgba(
                  appliedTheme?.previewPanelHeader?.backgroundColor
                ),
              },
            })}
          >
            <div className="w-40 ml-auto">
              <Select
                placeholder={"Select country"}
                onChange={(e) => {
                  dispatch(setLanguage(e));
                }}
                selectedValue={lang}
                dropdownData={[
                  { name: "English", value: "en" },
                  { name: "French", value: "fr" },
                ]}
              />
            </div>
          </div> */}
          <div
            className={classNames(
              "relative w-full h-full calc(100vh - 300px) p-6 overflow-auto scroll-smooth scrollbar parent-container bg-[#f7f7ff]",
              // appliedTheme?.previewPanel?.backgroundColor ? "" : "bg-surface-03"          bg-[#f7f7ff]
            )}
            {...(appliedTheme?.previewPanel?.backgroundColor && {
              style: {
                backgroundColor: rgba(
                  appliedTheme?.previewPanel?.backgroundColor
                ),
              },
            })}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(AdminLayout);
